import $ from 'jquery';
import React from 'react';

import {APP_VIEW_DETAILS, APP_VIEW_LIST} from '../config';
import MapWrapper from '../containers/map-wrapper';

import Content from './content';
import Footer from './footer';

import Header from './header';

const SCROLL_OFFSET = 0.35;

class AppWrapper extends React.Component {
	static _scrollToTop(offset = SCROLL_OFFSET) {
		const height = Math.round(($(window).height() || 0) * offset);
		$(window).scrollTop(height);
	}

	componentDidMount() {
		this._scroll();
	}

	componentDidUpdate() {
		this._scroll();
	}

	_scroll() {
		if (this.props.view === APP_VIEW_LIST && this.props.previousLocation) {
			return;
		}

		if (
			this.props.view === APP_VIEW_LIST ||
			this.props.view === APP_VIEW_DETAILS
		) {
			AppWrapper._scrollToTop();
		}
	}

	render() {
		const props = this.props;

		return (
			<div
				className={`bsknacht17-app-wrapper js-bsknacht17-state--${props.view}`}
			>
				<Header {...props} />
				<MapWrapper id="map" {...props} />
				<Content />
				<Footer {...props} />
			</div>
		);
	}
}

export default AppWrapper;
